import { FC, memo } from 'react';
import { Stack } from '../UI';
import { LeaderboardProps } from './Leaderboard.types';
import { LeaderboardItem } from './LeaderboardItem/LeaderboardItem';

export const Leaderboard: FC<LeaderboardProps> = memo(({ leaders, currentUserUid }) => {
    return (
        <Stack spacing={8}>
            {leaders.map((leader, index) => (
                <LeaderboardItem key={index} leader={leader} isCurrentUser={leader.puid === currentUserUid} />
            ))}
        </Stack>
    );
});
